import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BillingTransactionStatus } from "@/types/billing-transactions";
import { useTranslation } from "react-i18next";

const BillingTransactionStatusField = ({
  value,
  onChange,
  label,
  error,
  withLabel = true,
  triggerClassName,
}: {
  value?: BillingTransactionStatus | "all statuses";
  onChange: (value: string) => void;
  label?: string;
  error?: string;
  withLabel?: boolean;
  triggerClassName?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="min-w-0">
      {withLabel && (
        <label className="text-sm font-medium text-gray-700 mb-1 text-uppercase">
          {label || t("billing.transactionStatus")}
        </label>
      )}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={`w-full flex justify-between border-2 focus:ring-0 focus:border-black hover:border-black ${triggerClassName ?? ""} ${
            error ? "border-red-500" : "border-black"
          }`}
        >
          <SelectValue placeholder="Choose status" />
        </SelectTrigger>

        <SelectContent>
          <SelectItem value="all statuses">
            {t("billing.allStatuses")}
          </SelectItem>

          <SelectItem value={BillingTransactionStatus.PENDING}>
            {t("billing.pending")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.PROCESSING}>
            {t("billing.processing")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.SUCCEEDED}>
            {t("billing.succeeded")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.FAILED}>
            {t("billing.failed")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.CANCELED}>
            {t("billing.canceled")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.REFUNDED}>
            {t("billing.refunded")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.PARTIALLY_REFUNDED}>
            {t("billing.partiallyRefunded")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.REQUIRES_ACTION}>
            {t("billing.requiresAction")}
          </SelectItem>
          <SelectItem value={BillingTransactionStatus.REQUIRES_PAYMENT_METHOD}>
            {t("billing.requiresPaymentMethod")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default BillingTransactionStatusField;
